"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQuerySerialize = void 0;
const core_1 = require("@comunica/core");
/**
 * A comunica actor for query-serialize events.
 *
 * Actor types:
 * * Input:  IActionQuerySerialize:      Query algebra.
 * * Test:   <none>
 * * Output: IActorQuerySerializeOutput: A serialized query string.
 *
 * @see IActionQuerySerialize
 * @see IActorQuerySerializeOutput
 */
class ActorQuerySerialize extends core_1.Actor {
    /* eslint-disable max-len */
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query serializing failed: none of the configured parsers were able to serialize for the query language "${action.queryFormat.language}" at version "${action.queryFormat.version}"} busFailMessage
     */
    /* eslint-enable max-len */
    constructor(args) {
        super(args);
    }
}
exports.ActorQuerySerialize = ActorQuerySerialize;
//# sourceMappingURL=ActorQuerySerialize.js.map